module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAoCAYAAAD6xArmAAABQElEQVRIie3XvytFUQAH8M973eRHkZKYLcpiMlgtlMH8JpOUiUH+B7NSFkoMSiaDkbLJGwwmFoVBvUUZeM9wzqvbi4frKsP91unee7r3c84959S9p1Rf1MwQKhiULQ1c4BD1JFZO4hh9GdF0TjGToIxddGEZZxnBTqxhFiul+qIxXGEH87/sbQ+ecFlGf6y8/yUKz3hBTzkH7MMkqfNxLORgdrTC07HkkjR8hL0czO1W+BoHOcBbhDX8JyngAi7gAi7gAv5ncPpjOoeRHMzuVng0llyShjexnoNZbYVruGnzQEn4f659Adf52eSt4gHD37k5wVs8/6qREwwI/7/fgm+F/cNUvH795N7LWNplQhiu20R4vX1hY1PFeWzop+kSlmwDG83JW4g9rWAsA9rMI5ZwUkptx6BXGMcsecNdPHoH4fE3vuE59BoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/phone_icon.png
// module id = kPBe
// module chunks = 4